import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import weatherChannelPlacement from "../../../assets/images/partner_dashboard/ad_designs/wc-ad-placement.jpg";
import wallStreetJournalPlacement from "../../../assets/images/partner_dashboard/ad_designs/wsj-ad-placement.jpg";
import espnPlacement from "../../../assets/images/partner_dashboard/ad_designs/espn-ad-placement.jpg";
import AdDesignPreview from "../../partner-dashboard/components/ad-designs/ad-design-preview";
import "./preview-carousel.styles.scss";

const propTypes = {
  template: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    previewPath: PropTypes.string.isRequired,
    placements: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryMimeType: PropTypes.string.isRequired
  }).isRequired
};

const items = [
  {
    key: "weatherChannel",
    src: weatherChannelPlacement,
    altText: "The Weather Channel",
    // coefficient by which to scale the ad preview
    adScale: 0.195,
    topPosition: "41.5%",
    leftPosition: "65%"
  },
  {
    key: "wallStreetJournal",
    src: wallStreetJournalPlacement,
    altText: "The Weather Channel",
    adScale: 0.186,
    topPosition: "65%",
    leftPosition: "70.5%"
  },
  {
    key: "espn",
    src: espnPlacement,
    altText: "The Weather Channel",
    adScale: 0.177,
    topPosition: "61%",
    leftPosition: "69.8%"
  }
];

const WebPreviewCarousel = ({ template }) => {
  const ref = useRef(null);
  const [containerWidth, setContainerWidth] = useState(1000);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const WEB_SIZE_RATIO = 0.83;
  const BG_SIZE_RATIO = 0.6;

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  // useLayoutEffect(() => {
  //   setContainerWidth(ref.current.clientWidth);
  // }, []);

  // useEffect(() => {
  //   const handleResize = () => {
  //     setContainerWidth(ref.current.clientWidth);
  //   };
  //   window.addEventListener("resize", handleResize);

  //   return _ => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // });

  const slides = items.map(item => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <div
          className="ad-design__carousel--sample-placement-bg"
          style={{
            backgroundImage: `url("${item.src}")`,
            width: containerWidth,
            height: containerWidth * BG_SIZE_RATIO
          }}
        >
          <div
            style={{
              position: "absolute",
              top: item.topPosition,
              left: item.leftPosition,
              width: containerWidth * item.adScale,
              height: containerWidth * item.adScale * WEB_SIZE_RATIO
            }}
          >
            <AdDesignPreview
              url={template.previewPath}
              mimeType={template.primaryMimeType}
              title={template.displayName}
              width={containerWidth * item.adScale}
              height={containerWidth * item.adScale * WEB_SIZE_RATIO}
              exactSize
            />
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div ref={ref} className="py-0">
      <Carousel
        className="ad-design__carousel"
        activeIndex={activeIndex}
        next={next}
        previous={previous}
      >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
      <small>
        * The above sample placements are for example purposes only. Your specific ad may be
        displayed on other websites.
      </small>
    </div>
  );
};

WebPreviewCarousel.propTypes = propTypes;

export default WebPreviewCarousel;
